import { NoticeType } from '@shared/config/notice'
import { OperationDetailsRs } from '@root/api/ump-ewallet'
import { PayStatusSBP, Status } from '../model/payment.types'
import { getStatusName } from './getStatusName'

export const getStatusNotice = (isSBP: boolean, payStatus: string, operationDetails?: OperationDetailsRs) => {
  if (isSBP) {
    switch (payStatus) {
      case PayStatusSBP.ACCEPTED:
        return NoticeType.SUCCESS
      case PayStatusSBP.REJECTED:
        return NoticeType.ERROR
      default:
        return NoticeType.WARNING
    }
  }

  if (operationDetails) {
    const statusName = getStatusName(operationDetails?.state as number)

    if (statusName === Status.SUCCESS) {
      return NoticeType.SUCCESS
    }
    if (statusName === Status.FAIL) {
      return NoticeType.ERROR
    }

    return NoticeType.WARNING
  }
}
